import styled from 'styled-components';

export const StyledButtonRow = styled.div`
  display: flex;

  button,
  a {
    white-space: nowrap;
    margin-right: 20px;
  }
`;

export const StyledFormattedQuoteMessage = styled.div`
  font-size: 16px;
  font-weight: 800;
  padding: 0 8px 0 8px;
  margin: 20px 0 16px 0;
`;
